import BLRequest from 'backendless-request'

import type { FlowrunnerRuntime } from './global'
import { createExtension } from './v2/create-extension'
import { crypto } from './v2/crypto'
import { z } from './v2/params'
import { getExtension } from './v2/registry'

// Installs the single global `Flowrunner` namespace shared by v1 and v2. Importing this module for its
// side effect guarantees the global exists before any service module is required. The v1 registration
// seam (`ServerCode`) starts null and is toggled per-require by v1/namespace.ts.

const flowrunnerRuntime: FlowrunnerRuntime = {
  Request: BLRequest,
  z,
  crypto,
  createExtension,
  getExtension,
  ServerCode: null,
}

global.Flowrunner = flowrunnerRuntime

export { flowrunnerRuntime }
